
import Vue from 'vue'
import JcdcBtn from '@/components/jcdc/JcdcBtn.vue'
import {
  VCard,
  VCol,
  VContainer,
  VFadeTransition,
  VForm,
  VIcon,
  VRow,
  VSubheader,
} from 'vuetify/lib'

export default Vue.extend({
  name: 'JcdcSearchForm',
  components: {
    JcdcBtn,
    VForm,
    VFadeTransition,
    VCard,
    VContainer,
    VRow,
    VCol,
    VSubheader,
    VIcon,
  },
  props: {
    excel: { type: Boolean, default: false },
    filter: { type: Boolean, default: false },
    pdf: { type: Boolean, default: false },
    reset: { type: Boolean, default: false },
    resetCustom: { type: Boolean, default: false },
    search: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    filterOnly: { type: Boolean, default: false },
  },
  data() {
    return {
      showFilter: true,
      valid: false,
    }
  },
  methods: {
    searchClick(clickEvent: string) {
      ;(this.$refs.form as Vue & { validate: () => boolean }).validate()
      if (this.valid) {
        this.$emit(clickEvent)
      }
    },
    btnClick(clickEvent: string) {
      this.$emit(clickEvent)
    },
    resetClick(clickEvent: string) {
      if (this.reset) {
        ;(this.$refs.form as Vue & { reset: () => boolean }).reset()
      } else {
        ;(
          this.$refs.form as Vue & {
            resetValidation: () => boolean
          }
        ).resetValidation()
        this.$emit(clickEvent)
      }
    },
  },
})
